import { render } from "./BtnReiniciarIntegracao.vue?vue&type=template&id=a179f5e8"
import script from "./BtnReiniciarIntegracao.vue?vue&type=script&lang=js"
export * from "./BtnReiniciarIntegracao.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__